// Central source of truth for the Bokun booking widget.
// Keeping the channel UUID + experience IDs in one place avoids duplicated-URL drift.

export const BOKUN_CHANNEL_UUID = 'ce4487ea-d62a-4eee-a6b9-c294ec001701';

// Experience IDs per trip, confirmed by the live widget content.
// (The Austria tour, experience 1112611, was discontinued in Oct 2026.)
export const BOKUN_EXPERIENCE = {
    slovakia: '1112612',
} as const;

export type TripKey = keyof typeof BOKUN_EXPERIENCE;

// data-src for an inline Bokun booking button (opens the on-page modal).
export const bokunDataSrc = (experienceId: string) =>
    `https://widgets.bokun.io/online-sales/${BOKUN_CHANNEL_UUID}/experience/${experienceId}?partialView=1`;

// Loader script that binds elements with class "bokunButton" to the Bokun modal.
export const BOKUN_LOADER_SRC =
    `https://widgets.bokun.io/assets/javascripts/apps/build/BokunWidgetsLoader.js?bookingChannelUUID=${BOKUN_CHANNEL_UUID}`;
